import {config} from "./config";
import {fetchWrapper} from "../_services/fetch";

export const endpoints = {
    user: {
        vat: (userId) => config.get_remote_api() + "/api/accounts/vat/" + userId,
        signup: () => config.get_remote_api() + "/api/accounts/signup",
        login: () => config.get_remote_api() + "/api/accounts/login",
        create: () => config.get_remote_api() + "/api/accounts/create",
        edit: (targetId) => config.get_remote_api() + "/api/accounts/" + targetId,
        delete: (targetId) => config.get_remote_api() + "/api/accounts/" + targetId,
        refreshToken: () => config.get_remote_api() + "/api/accounts/refresh-token",
        resetPassword: () => config.get_remote_api() + "/api/accounts/reset-password",
        forgotPassword: () => config.get_remote_api() + "/api/accounts/forgot-password",
        resendEmail: () => config.get_remote_api() + "/api/accounts/resend-email",
        verifyEmail: () => config.get_remote_api() + "/api/accounts/verify-email",
    },

    cart: {
        get: () => config.get_remote_api() + "/api/basket/get",
        add: () => config.get_remote_api() + "/api/basket/add",
        edit: () => config.get_remote_api() + "/api/basket/edit",
        submit: () => config.get_remote_api() + "/api/basket/submit",
        count: () => config.get_remote_api() + "/api/basket/count"
    },

    address: {
        order: () => config.get_remote_api() + "/api/addresses/order",
        get: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        count: (userId, search) => config.get_remote_api() + "/api/addresses/count/" + userId + fetchWrapper.getSearchParams(search),
        list: (userId, search) => config.get_remote_api() + "/api/addresses/list/" + userId + fetchWrapper.getSearchParams(search),
        add: (userId) => config.get_remote_api() + "/api/addresses/" + userId,
        edit: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        delete: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        deletes: (userId) => config.get_remote_api() + "/api/addresses/delete/" + userId,
    },

    carrier: {
        order: () => config.get_remote_api() + "/api/carriers/order",
        get: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
        count: (search) => config.get_remote_api() + "/api/carriers/count" + fetchWrapper.getSearchParams(search),
        list: (search) => config.get_remote_api() + "/api/carriers/list" + fetchWrapper.getSearchParams(search),
        add: () => config.get_remote_api() + "/api/carriers/add",
        edit: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
        delete: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
    },

    country: {
        order: () => config.get_remote_api() + "/api/countries/order",
    },

    payment: {
        get: (targetId) => config.get_remote_api() + "/api/payment/" + targetId,
        list: (search) => config.get_remote_api() + "/api/payment/list" + fetchWrapper.getSearchParams(search),
    },

    paypal: {
        info: () => config.get_remote_api() + "/api/paypal/info",
        create: () => config.get_remote_api() + "/api/paypal/create",
        capture: (orderId) => `${config.get_remote_api()}/api/paypal/capture/${orderId}`
    },

    order: {
        status: () => config.get_remote_api() + "/api/order/status-options",
        order: () => config.get_remote_api() + "/api/order/order",
    },

    device: {
        get: (userId, deviceId) => config.get_remote_api() + "/api/devices/get/" + userId + "/" + deviceId,
        add: (userId) => config.get_remote_api() + "/api/devices/add/" + userId,
        edit: (userId, deviceId) => config.get_remote_api() + "/api/devices/edit/" + userId + "/" + deviceId,
        delete: (userId, deviceId) => config.get_remote_api() + "/api/devices/delete/" + userId + "/" + deviceId,
        list: (userId, deviceClass) => config.get_remote_api() + "/api/devices/list/" + userId + "/" + deviceClass,
        listFilter: (userId) => config.get_remote_api() + "/api/devices/list/" + userId,
        count: (userId, deviceClass) => config.get_remote_api() + "/api/devices/count/" + userId + "/" + deviceClass,
        countFilter: (userId) => config.get_remote_api() + "/api/devices/count/" + userId,
        query: (serial) => config.get_remote_api() + "/api/devices/query?serial=" + serial,
        orderOptions: () => config.get_remote_api() + "/api/devices/order",
    },

    icon: {
        get: (iconId) => iconId ? config.get_remote_api() + "/api/icons/" + iconId : null,
        list: (userId) => config.get_remote_api() + "/api/icons/list/" + userId,
    },

    automation: {
        get: (userId, automationId) => config.get_remote_api() + "/api/automations/" + userId + "/" + automationId,
        add: (userId) => config.get_remote_api() + "/api/automations/" + userId,
        count: (userId, search) => config.get_remote_api() + "/api/automations/count/" + userId + fetchWrapper.getSearchParams(search),
        list: (userId) => config.get_remote_api() + "/api/automations/list/" + userId,
        edit: (targetId, automationId) => config.get_remote_api() + "/api/automations/edit/" + targetId + "/" + automationId,
    },

    event: {
        get: (eventId) => config.get_remote_api() + "/api/events/get/" + eventId,
        add: (deviceId) => config.get_remote_api() + "/api/events/add/" + deviceId,
        edit: (eventId) => config.get_remote_api() + "/api/events/edit/" + eventId,
        count: (deviceId) => config.get_remote_api() + "/api/events/count/" + deviceId,
        list: (deviceId) => config.get_remote_api() + "/api/events/list/" + deviceId,
        del: (eventId) => config.get_remote_api() + "/api/events/delete/" + eventId,
    },

    push: {
        // EventSource (SSE) does not natively support custom headers to add Bearer, so use search param to send auth token (JWT)
        onlineDevs: (userId, jwt) => config.get_remote_api() + "/api/push/" + userId + "/online-devs?token=" + jwt,
        filterFields: (userId, deviceId, jwt, fields) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/filter-fields?token=" + jwt + "&fields=" + fields.join("_"),
        allFields: (userId, deviceId, jwt) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/all-fields?token=" + jwt,
        liveControl: (userId, deviceId) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/live-control",
        volume: (userId, deviceId) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/volume",
        reboot: (userId, deviceId) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/reboot",
    },

    product: {
        query: (sku) => config.get_remote_api() + "/api/products/query/" + sku,
    },

    contact: {
        sendEmail: () => config.get_remote_api() + "/api/contact/send-email",
        recaptcha: () => config.get_remote_api() + "/api/contact/recaptcha",
    },

    subscription: {
        count: (userId, search) => config.get_remote_api() + "/api/subscription/count/" + userId + fetchWrapper.getSearchParams(search),
        orderOptions: () => config.get_remote_api() + "/api/subscription/order",
        list: (userId, search) => config.get_remote_api() + "/api/subscription/list/" + userId + fetchWrapper.getSearchParams(search),
        get: (articleId) => config.get_remote_api() + "/api/subscription/get/" + articleId,
        filter: (userId) => config.get_remote_api() + "/api/subscription/filter/" + userId,
    },

    announcement: {
        count: (userId, search) => config.get_remote_api() + "/api/announcement/count/" + userId + fetchWrapper.getSearchParams(search),
        orderOptions: () => config.get_remote_api() + "/api/announcement/order",
        list: (userId, search) => config.get_remote_api() + "/api/announcement/list/" + userId + fetchWrapper.getSearchParams(search),
        get: (userId, announcementId) => config.get_remote_api() + "/api/announcement/get/" + userId + "/" + announcementId,
        add: (userId) => config.get_remote_api() + "/api/announcement/add/" + userId,
        stream: (userId, announcementId) => config.get_remote_api() + "/api/announcement/stream/" + userId + "/" + announcementId,
        size: (userId) => config.get_remote_api() + "/api/announcement/size/" + userId,
        edit: (userId, announcementId) => config.get_remote_api() + "/api/announcement/edit/" + userId + "/" + announcementId,
        delete: (userId, announcementId) => config.get_remote_api() + "/api/announcement/delete/" + userId + "/" + announcementId,
        limit: () => config.get_remote_api() + "/api/announcement/limit",
    },

    discount: {
        orderOptions: () => config.get_remote_api() + "/api/discount/order",
        count: (search) => config.get_remote_api() + "/api/discount/count" + fetchWrapper.getSearchParams(search),
        list: (search) => config.get_remote_api() + "/api/discount/list" + fetchWrapper.getSearchParams(search),
        get: (discountId) => config.get_remote_api() + "/api/discount/" + discountId,
        add: () => config.get_remote_api() + "/api/discount/add",
        edit: (discountId) => config.get_remote_api() + "/api/discount/edit/" + discountId,
        delete: (discountId) => config.get_remote_api() + "/api/discount/delete/" + discountId,
        use: (discountCode) => config.get_remote_api() + "/api/discount/use/" + discountCode,
    }
}